module.exports = __webpack_public_path__ + "img/lb.45d12f1d.svg";